import type { PatientAdminApiRouterOutputs } from '@liza/patient-admin-api';
import { toVitalUnitDisplay } from '@liza/ui/components/records';

type LookupPropertyValue = PatientAdminApiRouterOutputs['codeSystem']['lookup']['properties'][string];

// LOINC returns SI units for some vital signs; override with US-preferred clinical units.
// Celsius → Fahrenheit: US clinical convention displays temperature in °F.
const UNIT_OVERRIDES: Record<string, string> = {
  Cel: '[degF]',
};

export type VitalLookupProps = {
  unit: string | undefined;
  unitDisplay: string | undefined;
};

export const parseVitalLookupProps = (
  properties: Record<string, LookupPropertyValue> | undefined,
): VitalLookupProps => {
  const raw = properties?.EXAMPLE_UCUM_UNITS;
  if (!raw) return { unit: undefined, unitDisplay: undefined };
  const first = Array.isArray(raw) ? raw[0] : raw;
  const rawUnit = first?.value.split(';')[0]?.trim() || undefined;
  if (!rawUnit) return { unit: undefined, unitDisplay: undefined };
  const unit = UNIT_OVERRIDES[rawUnit] ?? rawUnit;
  const unitDisplay = toVitalUnitDisplay(unit);
  return { unit, unitDisplay };
};
